import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { useAuth } from '../context/AuthContext';
import { setMyLanguage } from '../api/admin';
import { translate } from './translations';

// Permissions & History Development Plan (13.10.2026), Phase 5 — "New
// personal setting: German or English. It is saved... controls menu, Case
// Control, My Tasks, History and status labels. The language changes
// neither country assignment nor access rights." Saved on the user's own
// row (users.preferred_language), already returned whole by every /me and
// login response, so this context just mirrors it.
const LanguageContext = createContext({ language: 'en', setLanguage: () => {}, t: (s) => s });

export function LanguageProvider({ children }) {
  const { user } = useAuth();
  const [language, setLanguageState] = useState('en');

  useEffect(() => {
    if (user?.preferred_language) setLanguageState(user.preferred_language);
  }, [user?.preferred_language]);

  const setLanguage = useCallback(async (lang) => {
    const res = await setMyLanguage(lang);
    setLanguageState(res.data?.preferred_language || lang);
    return res;
  }, []);

  const t = useCallback((key) => translate(language, key), [language]);

  return <LanguageContext.Provider value={{ language, setLanguage, t }}>{children}</LanguageContext.Provider>;
}

export function useLanguage() {
  return useContext(LanguageContext);
}
